var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          ref: "elTable",
          staticStyle: { width: "100%" },
          attrs: { border: "", data: _vm.tableList },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "outerOrderNo",
              label: _vm.$t("InternalSalesOrderDetails.party"),
              align: "center",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "logisticsNo",
              label: _vm.$t("OrdinaryOrderMix.LogisticsTable.logisticsNo"),
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.openTrackingDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.logisticsNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "logisticsCompany",
              label: _vm.$t("OrdinaryOrderMix.LogisticsTable.logisticsCompany"),
              align: "center",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "logisticsBusinessName",
              label: _vm.$t(
                "OrdinaryOrderMix.LogisticsTable.logisticsBusinessName"
              ),
              align: "center",
              "min-width": "200",
            },
          }),
          !_vm.$store.getters.cusId
            ? _c("el-table-column", {
                attrs: {
                  prop: "totalCharge",
                  label: _vm.$t("OrdinaryOrderMix.LogisticsTable.totalPrice"),
                  align: "center",
                  "min-width": "200",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              scope.row.totalCharge
                                ? (scope.row.totalCharge - 0).toFixed(2)
                                : scope.row.totalCharge
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  994997580
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("DeliverDialog", { ref: "DeliverDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }